// extracted by mini-css-extract-plugin
export default {"bounce":"N_dq","loading":"N_dr","logo-mark-bounce-right":"N_ds","logo-mark-bounce-left":"N_dt"};